<div [ngClass]="isChatbotPopupVisible ? 'app-container chatbot-visible platform-web' : 'app-container platform-web'" appInterceptCopyPast appIntelPropSecurity>
  @if (isHeaderVisible) {
    <header class="app-header">
      <app-header [menuItems]="appMenuItems"></app-header>
    </header>
  }
  <section class="app-main-content">
    <router-outlet></router-outlet>
  </section>
</div>
